/* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable import/extensions */
import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { Col, Row, Button, Card, Badge, Image, Modal, Form, InputGroup, } from 'react-bootstrap';
import { FaCheck, FaXmark, FaCoins } from 'react-icons/fa6';
import { cart, format, generator, } from '@/helpers/index';
import { isMobile } from 'react-device-detect';
import Divider from './divider';
import VehicleDataInfoComponent from './site/vehicle-data-info';
import SalesCommunication from './site/sales-communication';
import QuickInquiry from './quick-inquiry';
import { InputNumber } from 'primereact/inputnumber';

export default function Products({ items, plate, partner, ignore }) {
  const router = useRouter();
  const [type, setType] = useState('INDIVIDUAL');
  const [credit, setCredit] = useState(100);
  const [paymentShow, setPaymentShow] = useState(false);
  const [communicationShow, setCommunicationShow] = useState(false);
  const [dataInfoShow, setDataInfoShow] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState();

  const handleWhatsApp = () => {
    const phone = '?phone=553190612941';
    let url = `https://api.whatsapp.com/send/${phone}`;
    if (isMobile) {
      url = `whatsapp://send${phone}`;
    }
    window.open(`${url}&text=Olá, quero fazer uma consulta.`, '_blank');
  };

  const handleWhatsAppEnterprise = (product) => {
    const phone = '?phone=553199036492';
    let url = `https://api.whatsapp.com/send/${phone}`;
    if (isMobile) {
      url = `whatsapp://send${phone}`;
    }
    window.open(`${url}&text=Olá, quero o ${product}.`, '_blank');
  };

  const getSalesCommunication = () => {
    return items.find((el) => el.code.includes('COMUNICACAOVENDA')) ?? {
      name: 'Comunicação Venda',
      code: 'COMUNICACAOVENDA',
      i18n: 'comunicacao-venda',
      value: 79
    };
  }

  const getDetails = (code) => {
    const product = items.find((el) => el.code.includes(code));
    if (!product) { return []; }
    const result = [];
    const skip = ['Número do renavam', 'Decodificador de chassi', 'Gráfico de preço', 'Score de leilão', 'Vistoria especial', 'Proprietários', 'Acessórios'];
    for (const detail of product.details) {
      if (skip.includes(detail)) { continue; }
      let value = detail;
      if (detail === 'Ficha Técnica') {
        value += ` + Acessórios`;
      }
      result.push(value);
    }
    return result;
  };

  const getClassName = (value) => {
    const clazz = type === value ? 'active' : '';
    return `oswald ${clazz}`;
  };

  const getVariant = (value) => {
    return type === value ? 'dark' : 'light';
  };

  const handlePayment = (product) => {
    setSelectedProduct(product);
    // setPaymentShow(true);
    router.push(`/consulta/rapida/${product.i18n}`);
  };

  const handleCommunication = () => {
    // setCommunicationShow(true);
    router.push('/comunicacao-venda');
  };

  const getProductValue = (product) => {
    const value = `${product.value}`.split('.')[0];
    return `R$${value}`;
  };

  const hasDetail = (detail, code) => {
    const product = items.find((el) => el.code.includes(code));
    const has = product.details.find((el) => detail === el || (detail.includes(el) && el !== 'Dados cadastrais'));
    return has ? <FaCheck className="text-success" /> : <FaXmark className="text-danger" />;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!credit) {
      layout.nameFocus('credit', 100, true);
      return;
    }
    cart.dispatch({
      type: 'ADD',
      payload: {
        name: 'Crédito Avulso',
        value: credit,
      },
    });
  };

  return (
    <>
      {!partner && (
        <>
          <section id="consultas-section" className="text-center my-4">
            <h2 className="display-5 fw-extrabold text-dark mb-4">Consultas</h2>
            {!ignore && (
              <div className="segmented-control p-1 border rounded-pill d-inline-flex align-items-center shadow-sm">
                <button
                  type="button"
                  className={`btn rounded-pill px-4 py-2 fw-bold border-0 ${type === 'INDIVIDUAL' ? 'btn-gradient-primary shadow-sm' : 'text-secondary'}`}
                  onClick={() => setType('INDIVIDUAL')}
                >
                  Individual
                </button>
                <button
                  type="button"
                  className={`btn rounded-pill px-4 py-2 fw-bold border-0 ${type === 'ENTERPRISE' ? 'btn-gradient-primary shadow-sm' : 'text-secondary'}`}
                  onClick={() => setType('ENTERPRISE')}
                >
                  Empresarial
                </button>
              </div>
            )}
          </section>
          {type === 'ENTERPRISE' && (
            <section className="text-center">
              <Row className="my-4 g-4 justify-content-center">
                <Col xs={12} sm={6} lg={4}>
                  <Card className="border border-primary border-2 equal-height position-relative rounded-4 shadow-sm h-100">
                    <div className="ribbon ribbon-top-right"><span>Destaque</span></div>
                    <Card.Body className="mx-2 p-4 d-flex flex-column h-100">
                      <Card.Title><div className="h5 my-2 fw-bold text-dark">Pacote Especial - 25% OFF</div></Card.Title>
                      <div className="text-muted">
                        <strong>10 consultas completas</strong>
                        <div>Todos os dados disponíveis</div>
                      </div>
                      <p className="h4 fw-bold text-danger mt-3 mb-1">
                        <span>de </span>
                        <s>R$890</s>
                      </p>
                      <p className="h2 fw-extrabold text-primary mb-3">
                        <span>por </span>
                        <span>R$667</span>
                        <small className="text-muted fs-6">,50</small>
                      </p>
                      <div className="d-grid gap-2 mb-2 mt-auto">
                        <Button type="button" className="btn-gradient-primary rounded-pill py-2 fw-bold border-0" onClick={() => handleWhatsAppEnterprise('Pacote Especial - 25OFF')}>Comprar Agora</Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col xs={12} sm={6} lg={4}>
                  <Card className="equal-height border-0 shadow-sm rounded-4 h-100">
                    <Card.Body className="mx-2 p-4 d-flex flex-column h-100">
                      <Card.Title><div className="h5 my-2 fw-bold text-dark">Sob Medida</div></Card.Title>
                      <p className="text-muted small">
                        <strong>Cada empresa tem uma demanda diferente e entendemos isso. </strong>
                      </p>
                      <p className="text-secondary small text-start">
                        Entre em contato agora mesmo com nosso time de especialistas e receba em instantes um orçamento de acordo com a necessidade da sua empresa.
                      </p>
                      <div className="d-grid gap-2 mb-2 mt-auto">
                        <Button type="button" variant="outline-primary" className="rounded-pill py-2 fw-bold border-2" onClick={() => handleWhatsAppEnterprise('Plano Sob Medida')}>Fale com Especialista</Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <Divider color="gray" />
            </section>
          )}
          {type === 'INDIVIDUAL' && (
            <>
              <Row className="my-4 g-4">
                {items.filter((el) => !el.code.includes('COMUNICACAOVENDA')).map((product, index) => (
                  <Col xs={12} sm={6} lg={3} key={generator.token()}>
                    <Card className={`card-individual border-0 shadow-sm rounded-4 position-relative ${product.promote ? 'border border-primary border-2 shadow' : ''}`}>
                      {product.promote && <div className="ribbon ribbon-top-right"><span>Mais Popular</span></div>}
                      <Card.Body className="p-4">
                        <Card.Title className="product-card-title mb-2">
                          <div className="h4 mb-0 fw-bold text-dark">{product.name}</div>
                        </Card.Title>
                        <p className="product-card-desc text-secondary small mb-3">{product.description}</p>
                        {product.cashback >= 5 && (
                          <div className="mb-3">
                            <span className="badge rounded-pill bg-success-subtle text-success border border-success-subtle px-3 py-2 fw-bold d-inline-flex align-items-center gap-1 shadow-sm">
                              <FaCoins className="text-warning flex-shrink-0" />
                              <span>{product.cashback}% de Cashback</span>
                              <span className="badge bg-success text-white rounded-pill ms-1">
                                +{format.currency(product.value * (product.cashback / 100))} de volta
                              </span>
                            </span>
                          </div>
                        )}
                        <div className="my-3">
                          <span className="h1 fw-extrabold text-primary">{getProductValue(product)}</span>
                          <small className="text-muted fs-6">/consulta</small>
                          {product.cashback >= 5 && (
                            <div className="text-success small fw-bold mt-1">
                              Custo efetivo: {format.currency(product.value - (product.value * (product.cashback / 100)))}
                            </div>
                          )}
                        </div>
                        <div className="d-grid gap-2">
                          <Button type="button" className="btn-gradient-primary rounded-pill py-2 fw-bold border-0" onClick={() => handlePayment(product)}>
                            Comprar Agora
                          </Button>
                        </div>
                      </Card.Body>
                      <Card.Footer className="bg-light-subtle border-top-0 p-4 rounded-bottom-4">
                        <p className="text-uppercase fw-bold text-muted small mb-3">O que está incluso</p>
                        <ul className="list-unstyled mb-0 pe-2">
                          {product.cashback >= 5 && (
                            <li className="my-2 d-flex align-items-start small text-success fw-bold" key={`cashback-${product._id || product.code}`}>
                              <FaCoins className="text-warning me-2 mt-1 flex-shrink-0" />
                              <span>{product.cashback}% de cashback para sua próxima consulta</span>
                            </li>
                          )}
                          {getDetails(product.code).map((detail) => (
                            <li className="my-2 d-flex align-items-start small text-secondary" key={generator.token()}>
                              <FaCheck className="text-success me-2 mt-1 flex-shrink-0" />
                              <span>{detail}</span>
                            </li>
                          ))}
                        </ul>
                      </Card.Footer>
                    </Card>
                  </Col>
                ))}
              </Row>
              <Row className="my-4">
                <Col sm={2} lg={3} className="d-none d-sm-block"></Col>
                <Col xs={12} sm={8} lg={6} className="d-grid gap-2">
                  <Button type="button" variant="outline-primary" size="lg" className="rounded-pill fw-bold py-3 shadow-sm border-2" onClick={() => setDataInfoShow(true)}>
                    Veja todos os dados que disponibilizamos
                  </Button>
                </Col>
                <Col sm={2} lg={3} className="d-none d-sm-block"></Col>
              </Row>
              <section className="text-center my-4">
                <Row>
                  <Col sm={3} lg={4} className="d-none d-sm-block"></Col>
                  <Col xs={12} sm={6} lg={4}>
                    <Card className="border border-primary border-1 auto-height position-relative rounded-4 shadow-sm my-1">
                      <div className="ribbon ribbon-top-right"><span>Promoção</span></div>
                      <Card.Body className="p-4">
                        <Card.Title><div className="h4 mb-2 fw-bold text-dark">Comunicação de Venda</div></Card.Title>
                        <div className="text-muted small">
                          <span>Vendeu seu veículo?</span>
                          <div>Faça a Comunicação de Venda agora mesmo.</div>
                        </div>
                        <p className="h1 fw-extrabold text-primary my-3">{getProductValue(getSalesCommunication())}<small className="text-muted fs-6">/cada</small></p>
                        <div className="d-grid gap-2 mb-2 mt-3">
                          <Button type="button" className="btn-gradient-primary rounded-pill py-2 fw-bold border-0" onClick={handleCommunication}>Fazer Agora</Button>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col sm={4} className="d-none d-sm-block"></Col>
                </Row>
              </section>
              <Divider color="gray" />
              <section className="py-2 py-md-4 py-xl-8">
                <Row className="gy-5 gy-lg-0 align-items-lg-center">
                  <h2 className="h1 oswald text-center d-sm-none">Consulta de Placa pelo seu WhatsApp</h2>
                  <p className="lead fs-4 text-secondary text-center d-sm-none mt-2">Tudo que você precisa para garantir a segurança da sua negociação!</p>
                  <Col xs={12} lg={5} className="text-end d-none d-lg-block">
                    <Image src="/assets/themes/default/images/whatsapp-flow.png" width="371" height="731" border="0" alt="Atendimento pelo WhatsApp" className="img-fluid" fetchPriority="high" quality={100} />
                  </Col>
                  <Col xs={12} lg={7}>
                    <Row className="justify-content-xl-end">
                      <Col xs={12} xl={11}>
                        <h2 className="h1 oswald mb-3 d-none d-sm-block">Consulta de Placa pelo seu WhatsApp</h2>
                        <p className="lead fs-4 text-secondary mb-5 d-none d-sm-block">Tudo que você precisa para garantir total segurança na sua negociação!</p>
                        <div className="d-flex mb-4">
                          <div>
                            <span className="btn btn-primary bsb-btn-circle pe-none me-4">1</span>
                          </div>
                          <div>
                            <div className="h4 mb-3 oswald">Envie a Placa</div>
                            <p className="mb-0 text-secondary">
                              Nosso fluxo aceita placas nos dois formatos: Novo (MERCOSUL) e Antigo.
                              <br />
                              <span>Exemplo: </span>
                              <strong>AAA1A11</strong>
                              <span> ou </span>
                              <strong>AAA1111</strong>
                            </p>
                          </div>
                        </div>
                        <div className="d-flex mb-4">
                          <div>
                            <span className="btn btn-primary bsb-btn-circle pe-none me-4">2</span>
                          </div>
                          <div>
                            <div className="h4 mb-3 oswald">Escolha a Consulta e efetue o Pagamento</div>
                            <div className="mb-0 text-secondary">
                              <ul className="m-0">
                                <li>Selecione a consulta que deseja</li>
                                <li>Receba o código PIX</li>
                                <li>Efetue o pagamento</li>
                                <li>Notificação de consulta em processamento</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex">
                          <div>
                            <span className="btn btn-primary bsb-btn-circle pe-none me-4">3</span>
                          </div>
                          <div>
                            <div className="h4 mb-3 oswald">Receba o Relatório</div>
                            <p className="mb-0 text-secondary">Ao receber sua confirmação, basta clicar no link para ter acesso a todas informações.</p>
                          </div>
                        </div>
                        <Col xs={12} className="h3 mt-4 text-center text-sm-start fw-bold text-dark">
                          Viu como é fácil?
                        </Col>
                        <div className="d-grid gap-2 my-4">
                          <Button type="submit" size="lg" className="btn-gradient-primary rounded-pill py-3 fw-bold border-0 shadow" onClick={handleWhatsApp}>Comprar pelo WhatsApp Agora</Button>
                        </div>
                        <Col xs={12} className="text-center d-lg-none">
                          <Image src="/assets/themes/default/images/whatsapp-flow.png" width="371" height="731" border="0" alt="Atendimento pelo WhatsApp" className="img-fluid" fetchPriority="high" quality={100} />
                        </Col>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </section>
              {!ignore && (
                <div className="table-responsive border-0 shadow-sm rounded-4 overflow-hidden my-5">
                  <table className="table table-hover align-middle mb-0">
                    <thead className="bg-light border-bottom">
                      <tr>
                        <th scope="col" className="p-3"></th>
                        {items.filter((el) => !el.code.includes('COMUNICACAOVENDA')).map((product) => (
                          <td scope="col" key={generator.token()} className="text-center no-wrap p-3">
                            {product.promote && <span className="badge bg-primary text-white rounded-pill px-3 py-1 text-uppercase fw-bold mb-1 fs-8">Mais Popular</span>}
                            <div className="h5 my-2 fw-bold text-dark">{product.name}</div>
                          </td>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {getDetails('COMPLETA').map((detail) => (
                        <tr key={generator.token()}>
                          <th scope="row" className="no-wrap p-3 fw-semibold text-secondary">{detail}</th>
                          <td className="text-center p-3">{hasDetail(detail, 'COMPLETA')}</td>
                          <td className="text-center p-3">{hasDetail(detail, 'LEILAOESPECIAL')}</td>
                          <td className="text-center p-3">{hasDetail(detail, 'BASICA')}</td>
                          <td className="text-center p-3">{hasDetail(detail, 'HISTORICOTRANSFERENCIA')}</td>
                        </tr>
                      ))}
                      <tr>
                        <th className="p-3"></th>
                        {items.filter((el) => !el.code.includes('COMUNICACAOVENDA')).map((product) => (
                          <th className="text-center p-3" key={generator.token()}>
                            <p className="h2 fw-extrabold text-primary mb-2">{getProductValue(product)}<small className="text-muted fs-6">/cada</small></p>
                            <Button className="btn-gradient-primary rounded-pill px-4 py-2 fw-bold border-0 shadow-sm text-capitalize no-wrap" onClick={() => handlePayment(product)}>Comprar agora</Button>
                          </th>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </>
          )}
          {paymentShow && (
            <Modal show onHide={() => setPaymentShow(false)} size="xl" aria-labelledby="contained-modal-title-vcenter" centered className="no-header">
              <Modal.Header closeButton className="pb-0" />
              <Modal.Body className="mt-0 pt-0 px-1">
                <QuickInquiry options={{ warning: '', product: selectedProduct, plate: '', tag: '', }} />
              </Modal.Body>
            </Modal>
          )}
          {communicationShow && (
            <Modal show onHide={() => setCommunicationShow(false)} size="xl" aria-labelledby="contained-modal-title-vcenter" centered className="no-header">
              <Modal.Header closeButton className="pb-0" />
              <Modal.Body className="mt-0 pt-0 px-1">
                <SalesCommunication options={{ warning: '', product: getSalesCommunication() }} />
              </Modal.Body>
            </Modal>
          )}
          {dataInfoShow && (
            <Modal show onHide={() => setDataInfoShow(false)} size="xl" aria-labelledby="contained-modal-title-vcenter" centered className="vehicle-data-info-modal">
              <Modal.Header closeButton className="border-0 pb-0" />
              <Modal.Body className="pt-0 px-2 px-md-3 pb-4">
                <VehicleDataInfoComponent />
              </Modal.Body>
            </Modal>
          )}
        </>
      )}
      {partner && (
        <Row className="single-credit mb-3">
          <Col lg={12} className="mb-2">
            <h2 className="featurette-heading text-center">Crédito Avulso</h2>
            <div className="lead text-center">
              <strong>Agora você pode comprar créditos do seu jeito!</strong>
              <br />
              Seja para completar o valor de uma consulta ou simplesmente para garantir que não vai ficar sem saldo na hora de consultar.
            </div>
          </Col>
          <Col className="d-none d-sm-block">&nbsp;</Col>
          <Col>
            <Card className="shadow">
              <Card.Header className="p-3 pb-2 text-center" style={{ backgroundColor: '#000' }}>
                <div className="card-header-2">Adicionar Crédito</div>
              </Card.Header>
              <Card.Body>
                <Form onSubmit={onSubmit}>
                  <Row>
                    <Col>
                      <Form.Group className="mb-2 shadow-sm">
                        <InputGroup size="lg">
                          <InputNumber
                            id="credit"
                            name="credit"
                            value={credit}
                            onClick={(e) => e.target.select()}
                            onChange={(e) => setCredit(e.value)}
                            locale="pt-BR"
                            mode="currency"
                            currency="BRL"
                            className="form-control form-control-sm  no-border"
                            required
                            aria-label="Crédito Avulso" />
                          <Button type="submit" className="shadow">Comprar</Button>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </Col>
          <Col className="d-none d-sm-block">&nbsp;</Col>
        </Row>
      )}
    </>
  )
}
